<template>
	<h1 class="heading-xl" data-test="hero-heading">
		Invest in private assets like
		<span ref="assetTypeContainerRef" class="asset-type-container position-relative">
			<span v-for="(type, index) in assetTypes" :key="index" class="asset-type-item display-inline-block">
				<Transition name="asset-type" @enter="onTransitionEnter">
					<span
						v-if="index === currentAssetTypeIndex"
						class="asset-type-text display-inline-block no-wrap"
						:data-type="type"
						>{{ type }}</span
					>
				</Transition>
			</span>
			<span
				ref="borderRef"
				class="asset-type-border position-absolute bg-color-brand-primary"
				aria-hidden="true"
				:style="{ width: assetTypeTextWidth + 'px' }"
			></span>
		</span>
	</h1>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useIntervalFn } from '@vueuse/core';

const INTERVAL_DURATION_MS = 1750;
const assetTypes = ['venture capital', 'real estate', 'private credit'];
const currentAssetTypeIndex = ref(0);
const assetTypeContainerRef = ref<HTMLElement | null>(null);
const borderRef = ref<HTMLElement | null>(null);
const assetTypeTextWidth = ref(0);

useIntervalFn(() => {
	currentAssetTypeIndex.value = (currentAssetTypeIndex.value + 1) % assetTypes.length;
}, INTERVAL_DURATION_MS);

function onTransitionEnter(el: Element): void {
	assetTypeTextWidth.value = el.getBoundingClientRect().width;
}

onMounted(() => {
	// Initial width measurement
	setTimeout(() => {
		if (assetTypeContainerRef.value) {
			const firstTypeElement = assetTypeContainerRef.value.querySelector('.asset-type-text');
			if (firstTypeElement) {
				assetTypeTextWidth.value = firstTypeElement.getBoundingClientRect().width;
			}
		}
	}, 200);
});
</script>

<style scoped lang="scss">
@use '../../styles/utilities/respond-to.scss' as *;

.heading-xl {
	@include respond-to(mdo) {
		font-size: 3rem;
	}
}

.asset-type-container {
	display: inline-grid; // inline-grid keeps container a specific width regardless of content
	vertical-align: top;
	padding-bottom: 6px;
	min-width: 270px;

	@include respond-to(md) {
		justify-content: start;
		min-width: 292px;
	}
}

.asset-type-item {
	grid-area: 1 / 1;
}

.asset-type-border {
	bottom: 0;
	// Center the underline horizontally in mobile (container is centered)
	height: 4px;
	transition: width 0.3s ease;
}

.asset-type-enter-active,
.asset-type-leave-active {
	transition: opacity 0.3s ease;
}

.asset-type-enter-from,
.asset-type-leave-to {
	opacity: 0;
}
</style>
